import { createEvent, createStore } from 'effector';
import { $resetPanelState } from './client.entity';

export type ClientEventKind = 'stage' | 'error' | 'crash' | 'anr' | 'native' | 'abnormal_exit';
export type ClientEventSource = 'dropper' | 'payload';

export interface IClientEvent {
	id: number;
	clientId: string;
	buildId: string;
	source: ClientEventSource;
	kind: ClientEventKind;
	name: string;
	message: string;
	meta?: Record<string, unknown> | null;
	stackTrace?: string | null;
	threadName?: string | null;
	occurredAt: string | number;
	createdAt: string | number;
}

export const $setClientDetailEvents = createEvent<IClientEvent[]>();
export const $addClientDetailEvent = createEvent<IClientEvent>();
export const $appendClientDetailEvents = createEvent<IClientEvent[]>();

export const $clientDetailEvents = createStore<IClientEvent[]>([])
	.on($setClientDetailEvents, (_, payload) => payload)
	.on($addClientDetailEvent, (state, payload) => [payload, ...state])
	.on($appendClientDetailEvents, (state, payload) => {
		const existing = new Set(state.map(item => item.id));
		const merged = [...state];
		for (const item of payload) {
			if (existing.has(item.id)) continue;
			merged.push(item);
			existing.add(item.id);
		}
		return merged;
	})
	.reset($resetPanelState);
